module.exports = __webpack_public_path__ + "img/continents.09bfc170.png";